import { Link } from "react-router-dom";
import { articles } from "@/mocks/manhwa";

export default function ArticleSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精选文章
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            韩漫资讯、深度分析和阅读指南
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-full aspect-video overflow-hidden">
                <img
                  src={article.cover}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2.5">
                  <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded">
                    {article.category === "news" ? "韩漫资讯" : article.category === "analysis" ? "深度分析" : "阅读指南"}
                  </span>
                  <span>{article.publishDate}</span>
                  <span>· {article.readTime}分钟阅读</span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}